import { ModuleDetailPage } from '@/features/modules/pages/ModuleDetailPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/$wsSlug/projects/$projectSlug/modules/$moduleId')({
  component: ModuleDetailPage,
});
